import {ResearchLitElement, html, css, styleMap} from '@core/research-lit-element';

import '@bog-design-system/bd-tabs';

class ResearchSlider extends ResearchLitElement {
    static get is() {
        return 'research-slider';
    }

    static get styles() {
        return css`
            :host {
                --container-width: 100%;
                --item-margin-right: var(--space-24);
                --title-color: var(--color-invert-component-tr-30);
                --description-color: var(--color-invert-component-tr-40);
                --padding-bottom: 0px;
                --slider-margin-top: var(--space-40);
                --header-side-padding: var(--space-24);

                --scrollbar-track-background: transparent;
                --scrollbar-bar-width: 0px;
                --scrollbar-bar-height: 0px;
                --scrollbar-bar-background: transparent;
            }

            .slider-container {
                width: var(--container-width);
                position: relative;
                margin-top: var(--slider-margin-top);
            }

            .items-container-wrapper {
                overflow: hidden;
                width: var(--container-width);
                padding-bottom: var(--padding-bottom);
                scroll-behavior: smooth;
            }

            .items-container {
                position: relative;
                display: inline-flex;
                flex-direction: row;
                align-items: stretch;
                width: var(--container-width);
                transition: transform 0.3s;
            }

            .scrollable-wrapper {
                overflow-x: scroll;
                scroll-snap-type: x mandatory;
                width: var(--container-width);
                padding-bottom: var(--padding-bottom);
                scroll-behavior: smooth;
                -webkit-overflow-scrolling: touch;
                scrollbar-color: var(--scrollbar-bar-background) var(--scrollbar-track-background);
                scrollbar-width: none;
                scrollbar-base-color: var(--scrollbar-bar-background);
                scrollbar-face-color: var(--scrollbar-track-background);
                scrollbar-3dlight-color: var(--scrollbar-track-background);
                scrollbar-highlight-color: var(--scrollbar-track-background);
                scrollbar-track-color: var(--scrollbar-track-background);
                -ms-overflow-style: -ms-autohiding-scrollbar;
            }

            .scrollable-container {
                position: relative;
                display: inline-flex;
                flex-direction: row;
                align-items: stretch;
                width: var(--container-width);
                scroll-snap-type: x mandatory;
            }

            .scrollable-wrapper::-webkit-scrollbar,
            .scrollable-wrapper::-webkit-scrollbar-track {
                background: var(--scrollbar-track-background);
                width: var(--scrollbar-bar-width);
                height: var(--scrollbar-bar-height);
            }

            .scrollable-wrapper::-webkit-scrollbar-thumb,
            .scrollable-wrapper::-webkit-scrollbar-thumb:hover {
                width: var(--scrollbar-bar-width);
                height: var(--scrollbar-bar-height);
                background: var(--scrollbar-bar-background);
            }

            .items-slot::slotted(*) {
                margin-right: var(--item-margin-right);
            }

            :host([disable-click]) .items-slot::slotted(*) {
                pointer-events: none;
            }

            .offers-header-container {
                display: flex;
                flex-direction: row;
                align-self: flex-start;
                align-items: center;
                justify-content: center;
            }

            .title-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }

            .title {
                display: flex;
                width: inherit;
                margin-right: var(--space-16);
                color: var(--title-color);
            }

            .no-transition {
                transition: none !important;
            }

            .description {
                margin-top: var(--space-16);
                margin-bottom: var(--space-40);
                color: var(--description-color);
                text-align: center;
            }
          
              .tabs-container {
                display: flex;
                justify-content: center;
              }

            .tabs {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: var(--space-16);
              --height: unset;
              --tab-box-shadow: none;
              --tab-background-color: var(--color-invert-component-tr-80);
              align-self: var(--align-self);
            }

            .tab {
              --tab-height: 50px;
              margin-bottom: 6px;
            }
          
              .tab:hover {
                --tab-box-shadow: unset;
              }
          
            @media (max-width: 768px) {
                .offers-header-container,
                .description {
                    padding-left: var(--header-side-padding);
                    padding-right: var(--header-side-padding);
                }
            }

            @media (max-width: 600px) {
                .title {
                    max-width: max-content;
                }
            }
        `;
    }

    render() {
        return html`
            <div class="offers-header-container">
                <div class="title-container">
                    <bd-font type="${this.titleType}" class="title">
                        <h3>${this.title}</h3>
                    </bd-font>
                </div>
            </div>

            ${this.description ?
                html`
                      <div class="description">
                          <bd-font type="body1">
                              <span>${this.description}</span>
                          </bd-font>
                      </div>
                  ` :
                ``}
            ${this.cards?.length > 0 ?
                html`
                    <div class="tabs-container">
                        <bd-tabs
                                id="bd-tabs"
                                class="tabs"
                                type="round"
                                size="mini"
                                theme="light"
                                align="left"
                                attr-for-selected="name"
                                no-line-background
                        >
                            ${this.cards.map(
                                    (card, index) => html`
                          <bd-tab
                              class="tab"
                              slot="tab"
                              ?selected="${this.activeSlideIndex === index}"
                              state="${this.activeSlideIndex === index ? 'active' : 'inactive'}"
                              @click="${() => this._handleChipClick(card?.key, index)}"
                          >${card?.title}</bd-tab>
                      `
                            )}
                        </bd-tabs>
                    </div>
                  ` :
                ''}

            <div class="slider-container" id="slider-container">
                <div
                    class="items-container-wrapper"
                    @touchstart="${this._onTouchStart}"
                    @touchend="${this._onTouchEnd}"
                    @touchmove="${this._onTouchMove}"
                    @mousedown="${this._onTouchStart}"
                    @mouseup="${this._onTouchEnd}"
                    @mousemove="${this._onTouchMove}"
                    @mouseleave="${this._onTouchEnd}"
                >
                    <div
                        class="items-container"
                        style="${styleMap({transform: `translateX(${this._itemsContainerTranslateX}px)`})}"
                    >
                        <slot class="items-slot" id="items-slot" @slotchange="${this._onItemsSlotChange}"></slot>
                    </div>
                </div>
            </div>
        `;
    }

    static get properties() {
        return {
            itemsNumber: {
                type: Number,
                attribute: 'items-number',
            },
            itemsPerSlide: {
                type: Number,
                attribute: 'items-per-slide',
                reflect: true,
            },
            maxItems: {
                type: Number,
                attribute: 'max-items',
            },
            _totalItems: {
                type: Number,
            },
            _itemWidth: {
                type: Number,
            },
            _itemMarginRight: {
                type: Number,
            },
            itemMarginRightDefault: {
                type: Number,
                attribute: 'item-margin-right-default',
            },
            _renderedPortionStartIndex: {
                type: Number,
            },
            _itemsContainerTranslateX: {
                type: Number,
            },
            title: {
                type: String,
            },
            description: {
                type: String,
            },
            titleType: {
                type: String,
                reflect: true,
                attribute: 'title-type',
            },
            _previousEnabled: {
                type: Boolean,
            },
            _nextEnabled: {
                type: Boolean,
            },
            mouseOn: {
                type: Boolean,
                attribute: 'mouse-on',
            },
            disableClick: {
                type: Boolean,
                attribute: 'disable-click',
                reflect: true,
            },
            hideAmount: {
                type: Boolean,
                reflect: true,
                attribute: 'hide-amount',
            },
            solo: {
                type: Boolean,
                reflect: true,
            },
            direction: {
                type: String,
            },
            cards: {
                type: Array,
            },
            headerSidePadding: {
                type: Number,
                attribute: 'header-side-padding',
            },
            activeSlideIndex: {
                type: Number,
            },
        };
    }

    constructor() {
        super();
        this._nodes = [];
        this.itemsPerSlide = 1;
        this.maxItems = 20;
        this._totalItems = 0;
        this._itemWidth = 0;
        this._itemMarginRight = 0;
        this.itemMarginRightDefault = 24;
        this._itemsContainerTranslateX = 0;
        this._renderedPortionStartIndex = 0;
        this._previousEnabled = false;
        this._nextEnabled = false;
        this.disableClick = false;
        this.hideNavigation = false;
        this.direction = '';
        this.titleType = 'h3';
        this.cards = [];
        this.headerSidePadding = 416;
        this.activeSlideIndex = 0;
    }

    _getFirstSlottedElement(slotName) {
        const cardsContainer = this.shadowRoot.getElementById(slotName);
        return cardsContainer.assignedNodes().find(this._isHtmlElement);
    }

    _getItemWidth() {
        return this._getFirstSlottedElement('items-slot').offsetWidth;
    }

    _getItemMarginRight() {
        return this.itemMarginRightDefault;
    }

    _isHtmlElement(node) {
        return node instanceof HTMLElement;
    }

    _onItemsSlotChange(event) {
        const htmlNodes = event.target.assignedNodes().filter(this._isHtmlElement);
        if (htmlNodes.length > this.maxItems) {
            for (let i = this.maxItems; i < htmlNodes.length; i++) {
                htmlNodes[i].remove();
            }
        }

        const containerWidth = this.shadowRoot.querySelector('.items-container-wrapper').offsetWidth;

        this._nodes = htmlNodes;
        this._totalItems = htmlNodes.length;
        this._itemWidth = htmlNodes[0].offsetWidth;

        htmlNodes[0].style.marginLeft = `var(--header-side-padding)`;
        htmlNodes[this._totalItems - 1].style.marginRight = `var(--header-side-padding)`;

        this.itemsPerSlide = Math.floor(containerWidth / this._itemWidth);
        this._nextEnabled = this._totalItems > this.itemsPerSlide;
    }

    _slideItems(slideIndex) {
        this._itemWidth = this._getItemWidth();
        this._itemMarginRight = this._getItemMarginRight();
        this._itemsContainerTranslateX = -1 * (slideIndex * (this._itemWidth + this._itemMarginRight));
    }

    _onTouchStart(e) {
        this.shadowRoot.querySelector('.items-container').classList.add('no-transition');
        this._startingX = e.pageX || e.touches[0].pageX;
        this._startingTranslateX = -this._itemsContainerTranslateX;
        this.mouseOn = true;
    }

    _onTouchEnd(e) {
        if (!this.mouseOn || this._currentX === null || this._startingX === null) {
            this._startingX = null;
            return;
        }
        if (this.disableClick) {
            this.disableClick = false;
        }
        this.shadowRoot.querySelector('.items-container').classList.remove('no-transition');

        this.mouseOn = false;
        this._currentX = null;
        this._startingX = null;

        this.activeSlideIndex = this._getActiveSlide();
    }

    _onTouchMove(e) {
        if (!this.mouseOn) {
            return;
        }

        if (!this.disableClick && !this.isMobile) {
            this.disableClick = true;
        }

        if (this._startingX || this._startingX === 0) {
            this._currentX = e.pageX || e.touches[0].pageX;
            const dx = this._currentX - this._startingX;
            const itemWidth = this._getItemWidth();
            const itemMarginRight = this._getItemMarginRight();

            const minRight = (itemWidth + itemMarginRight) * (this.cards.length - 1);

            const xPosition = -1 * (this._startingTranslateX - dx);

            if (xPosition > 0) {
                return;
            } else if (xPosition < -1 * minRight) {
                return;
            } else {
                this._itemsContainerTranslateX = -1 * (this._startingTranslateX - dx);
            }
        }
    }

    _handleChipClick(key) {
        if (this.mouseOn) {
            this._renderedPortionStartIndex = 0;
        }
        this.shadowRoot.querySelector('.items-container').classList.remove('no-transition');
        const index = this.cards.findIndex((card) => card.key === key);
        this.activeSlideIndex = index;
        const targetSlide = Math.floor(index / this.itemsPerSlide);

        const currentSlide = this._getActiveSlide();
        // const diff = targetSlide - currentSlide;

        if (index === currentSlide) return;

        this._slideItems(targetSlide);
        this.dispatchEvent(new CustomEvent('tab-click', {
            detail: {value: key},
            bubbles: true,
            composed: true,
        }));
    }

    _getActiveSlide() {
        const container = this.shadowRoot.querySelector('.items-container');
        const style = window.getComputedStyle(container);
        const transform = style.getPropertyValue('transform');
        const matrix = new DOMMatrix(transform);
        const translateX = matrix.m41;

        const itemWidth = this._getItemWidth();
        const itemMarginRight = this._getItemMarginRight();

        return Math.abs(Math.round(-translateX / (itemWidth + itemMarginRight * this.itemsPerSlide)));
    }
}

window.customElements.define(ResearchSlider.is, ResearchSlider);
